/* import __COLOCATED_TEMPLATE__ from './segments.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();